export class LocationSale {
    id: number;
    name: string;
    subTotal: number;
    percent: number;
    averagePerHour: number;
    open: boolean;
    lastInvoice:string;

    constructor(locationSale: any) {
        Object.assign(this, locationSale);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/location/shared/models/location-sale.ts